import { render, staticRenderFns } from "./pageFaqItem.vue?vue&type=template&id=58ef958e&"
import script from "./pageFaqItem.vue?vue&type=script&lang=js&"
export * from "./pageFaqItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports